import { connectNetwork } from 'lib/NetworkProvider'
import View from 'lib/View'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { TOOLBAR_ACTIONS } from '../actions/toolbar'
import { Product } from '../components'

class SingleProduct extends Component {
    constructor(props) {
        super(props)
        let { product } = this.props.match.params

        this.state = {
            product,
        }
    }

    componentDidUpdate() {}

    componentDidMount() {}

    render() {
        let { product } = this.state
        // console.log('Loading product', product)
        return (
            <View column fullw fullh>
                <Product forcedOpen={true} showDetails={true} productId={product} type="full" />
            </View>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        toolbarRequest: (result) => TOOLBAR_ACTIONS.request(result, dispatch),
        toolbarResult: (result) => TOOLBAR_ACTIONS.result(result, dispatch),
        toolbarError: (result) => TOOLBAR_ACTIONS.error(result, dispatch),
    }
}

const mapStateToProps = (state) => {
    return {}
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(connectNetwork(SingleProduct)))